var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import './theme.scss';
import './interceptor/interceptor';
import Entry from './Entry';
import axios from 'axios';
const initializeApp = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axios.get(`/assets/config/${process.env.MANIFEST_FILE}`);
        Window.prototype.config = response.data['global-variables'];
        const root = createRoot(document.getElementById('root'));
        root.render(_jsx(Entry, {}));
    }
    catch (_a) {
        // manifest fetch failed
    }
});
initializeApp();
